(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("ReactDOM"), require("moment"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "ReactDOM", "moment"], factory);
	else if(typeof exports === 'object')
		exports["FocusComponents"] = factory(require("React"), require("ReactDOM"), require("moment"));
	else
		root["FocusComponents"] = factory(root["React"], root["ReactDOM"], root["moment"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_80__, __WEBPACK_EXTERNAL_MODULE_82__, __WEBPACK_EXTERNAL_MODULE_292__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition